import { styled } from "@mui/material/styles";
import {
  alpha,
  AppBar,
  Badge,
  Box,
  FormControl,
  IconButton,
  InputBase,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Toolbar,
  Typography,
  SelectChangeEvent,
} from "@mui/material";
import { useState } from "react";
import {
  AccountCircle,
  Mail,
  More,
  Notifications,
  Search as SearchIcon,
} from "@mui/icons-material";
import { STATES } from "./../assets/constants/index";

//import useNavigate from "hooks/Navigate";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SearchBar = ({ searchRef, handleSearch }) => {
  const [store, setStore] = useState("all");

  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const { language, setLanguage, t } = useTranslation();

  const navigate = useNavigate();

  const searchParams = new URLSearchParams(useLocation().search);
  let query = Object.fromEntries(searchParams);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const [age, setAge] = useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const menuId = "primary-search-account-menu";

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error">
            <Mail />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      {/* <Box sx={{ flexGrow: 1 }}> */}
      {/* <AppBar
        position="static"
        sx={{
          bgcolor: "var(--light)",
          color: "var(--dark)",
        }}
      > */}
      {/* <Toolbar> */}
      {/* <Search className="d-flex bg-light search-icon">
            <StyledInputBase
              inputRef={searchRef}
              placeholder={t("placeholders.search")}
              inputProps={{ "aria-label": "search" }}
            />
            <IconButton sx={{ color: "white" }} onClick={handleSearch}>
              <SearchIcon />
            </IconButton>
          </Search> */}
      <div className="search-con">
        <div className="left">
          <div className="wrap"  inputRef={searchRef}>
            <input type="search" placeholder="Start Typing To Search" />
            <img src="/assets/images/search.png" alt="search" className="search-icon"/>
          </div>
        </div>
        <div className="right">
          <FormControl fullWidth className="store-select-wrapper" >
            <InputLabel id="demo-simple-select-label">
              {t("labels.location")}
            </InputLabel>
            <Select
              defaultValue="all"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={t("labels.location")}
              className="store-select"
            >
              <MenuItem value={"all"} onClick={() => navigate(`?`)}>
                {t("labels.all")}
              </MenuItem>
              {STATES.sort().map((state) => (
                <MenuItem
                  key={state}
                  value={state}
                  selected={state === query.state}
                  onClick={() => navigate(`?state=${state}`)}
                >
                  {state}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
      {/* <Box sx={{ flexGrow: 1 }} /> */}

      {/*<Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
                            <Badge badgeContent={4} color="error">
                                <Mail />
                            </Badge>
                        </IconButton>
                        <IconButton
                            size="large"
                            aria-label="show 17 new notifications"
                            color="inherit"
                        >
                            <Badge badgeContent={17} color="error">
                                <Notifications />
                            </Badge>
                        </IconButton>
                        <IconButton
                            size="large"
                            edge="end"
                            aria-label="account of current user"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                    </Box>*/}
      {/*<Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="show more"
                            aria-controls={mobileMenuId}
                            aria-haspopup="true"
                            onClick={handleMobileMenuOpen}
                            color="inherit"
                        >
                            <More />
                        </IconButton>
                    </Box>*/}

      {/* </Toolbar> */}
      {/* </AppBar> */}
      {renderMobileMenu}
      {renderMenu}
      {/* </Box> */}
    </>
  );
};

export default SearchBar;

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    // vertical padding + font size from searchIcon
    paddingRight: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));
